module.exports = __webpack_public_path__ + "img/lr.c97fe015.svg";